import React, { Component } from 'react';
import styles from './Activity.scss';

export default class Activity extends Component {
    render() {
        const { activity } = this.props;
        return (
            <div className="activity-container flex flex-middle">
                {
                    !activity.is_read && activity.unread_count > 0 && <div className="flex flex-middle flex-center ht-15 wt-15 br-50p tCenter white-color mr-5 danger-background unread-count fs-12 fBold">
                        {
                            activity.unread_count
                        }
                    </div>
                }
                <span className="message-count fs-14 lh-15p">
                    {
                        activity.message_count
                    } <span className="ml-3 "> Message </span>
                </span>
                
            </div>
        )
    }
}
